module.exports = __webpack_public_path__ + "img/dialog_image_S202P_V1.d1b915d6.png";